import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private ws: PostmethodService) { }

  getUser() {
    return this.ws.wsGet(environment.baseUrl + "user/edit");
  }

  getStateByCountry(id: any) {
    return this.ws.wsGet(environment.baseUrl + "common/get-states-by-country/" + id);
  }

  getDistrictsByState(id: any) {
    return this.ws.wsGet(environment.baseUrl + "common/get-districts-by-state/" + id);
  }

  getLocationsByDistrict(id: any) {
    return this.ws.wsGet(environment.baseUrl + "common/get-location-by-district/" + id);
  }

  updateProfile(formData: any) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "user/update");
  }

  removePhoto() {
    return this.ws.wsGet(environment.baseUrl + "user/removeAvatar");
  }
}
